import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

const Header: React.FC = () => {
  const { t, i18n } = useTranslation();

  const changeLanguage = (lng: string) => {
    i18n.changeLanguage(lng);
  };

  return (
    <header className="bg-white shadow-md">
      <div className="container mx-auto px-6 py-4 flex justify-between items-center">
        <div className="text-2xl font-bold text-gray-800">
          <Link to="/">数智洞察</Link>
        </div>
        <nav className="hidden md:flex items-center space-x-6">
          <Link to="/" className="text-gray-600 hover:text-blue-600">{t('header.home')}</Link>
          <Link to="/dashboard" className="text-gray-600 hover:text-blue-600">{t('header.dashboard')}</Link>
          <Link to="/solutions" className="text-gray-600 hover:text-blue-600">{t('header.solutions')}</Link>
          <Link to="/about" className="text-gray-600 hover:text-blue-600">{t('header.about')}</Link>
          <Link to="/contact" className="text-gray-600 hover:text-blue-600">{t('header.contact')}</Link>
        </nav>
        <div className="flex items-center space-x-4">
          <Link to="/admin" className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700">
            {t('header.login')}
          </Link>
          <div>
            <button onClick={() => changeLanguage('zh')} className={`px-2 ${i18n.language === 'zh' ? 'font-bold' : ''}`}>中</button>
            <span className="text-gray-300">|</span>
            <button onClick={() => changeLanguage('en')} className={`px-2 ${i18n.language === 'en' ? 'font-bold' : ''}`}>EN</button>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
